import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">

<path d="M2035 6716 c-22 -7 -62 -24 -90 -38 -251 -129 -338 -475 -180 -723
69 -108 196 -193 327 -215 176 -31 378 60 475 214 54 85 76 164 77 271 0 116
-17 183 -69 271 -62 105 -163 184 -284 220 -55 17 -202 17 -256 0z"/>
<path d="M3700 6178 l0 -418 275 0 275 0 0 78 0 77 -190 -3 -190 -3 0 101 0
100 165 0 165 0 0 70 0 70 -165 0 -165 0 0 95 0 95 185 0 185 0 0 75 0 75
-247 1 c-137 0 -258 2 -270 3 l-23 3 0 -419z"/>
<path d="M6624 6591 c-2 -2 -4 -65 -4 -138 l0 -134 -32 24 c-66 49 -136 58
-227 31 -67 -19 -123 -70 -158 -142 -25 -51 -28 -68 -28 -157 0 -87 3 -107 26
-155 44 -93 114 -147 211 -165 54 -10 137 11 181 46 l37 30 0 -36 0 -35 80 0
80 0 -2 416 -3 416 -78 1 c-43 1 -81 0 -83 -2z m-74 -359 c97 -48 109 -241 19
-316 -15 -12 -43 -21 -74 -23 -63 -5 -106 19 -135 76 -28 55 -28 163 0 209 41
67 120 90 190 54z"/>
<path d="M7568 6453 l-3 -78 -41 -3 -42 -3 2 -61 1 -62 40 0 40 -1 5 -196 c5
-208 5 -206 60 -256 34 -30 114 -47 184 -39 l56 7 0 69 0 69 -50 -6 c-40 -5
-54 -2 -70 12 -18 17 -20 31 -20 182 l0 165 70 -4 70 -3 0 63 0 62 -70 0 -70
0 0 80 0 80 -80 0 -79 0 -3 -77z"/>
<path d="M4502 6381 c-77 -20 -152 -103 -152 -169 0 -20 5 -22 59 -22 33 0 66
-3 75 -6 11 -4 16 -1 16 10 0 9 11 28 25 41 27 28 85 34 128 14 29 -13 57 -58
57 -92 0 -24 -2 -24 -108 -30 -59 -3 -127 -13 -152 -22 -96 -34 -140 -115
-119 -217 31 -144 249 -185 372 -70 l27 26 0 -42 0 -42 71 0 71 0 -4 223 c-4
242 -10 272 -66 330 -47 50 -99 70 -187 73 -44 2 -95 -1 -113 -5z m208 -395
c0 -25 -8 -43 -31 -65 -35 -36 -59 -44 -119 -39 -33 2 -48 9 -64 31 -19 26
-19 30 -5 55 22 39 55 52 142 52 l77 0 0 -34z"/>
<path d="M7043 6376 c-22 -7 -56 -24 -73 -36 -34 -24 -69 -89 -70 -127 0 -21
4 -23 59 -23 33 0 66 -3 75 -6 11 -4 16 -1 16 10 0 9 11 28 25 41 29 30 97 34
133 9 26 -18 52 -65 52 -94 0 -18 -6 -20 -67 -20 -231 0 -346 -88 -312 -240
20 -91 121 -150 232 -136 59 8 92 24 130 61 l27 28 0 -42 0 -41 70 0 70 0 0
218 c-1 155 -5 228 -14 255 -36 99 -112 149 -235 154 -46 2 -93 -3 -118 -11z
m217 -386 c0 -20 -11 -42 -34 -67 -30 -33 -39 -37 -92 -41 -50 -3 -62 0 -81
18 -38 35 -28 84 21 106 17 7 66 13 109 14 l77 0 0 -30z"/>
<path d="M8120 6381 c-46 -14 -87 -40 -113 -71 -28 -33 -51 -100 -39 -111 4
-4 37 -9 74 -12 66 -5 67 -4 79 25 6 16 20 33 30 38 27 15 86 12 119 -5 33
-17 44 -35 53 -81 l6 -31 -107 -6 c-158 -8 -236 -43 -267 -119 -21 -54 -19
-106 8 -158 54 -109 233 -132 336 -43 l41 35 0 -41 0 -41 71 0 70 0 -3 223
c-3 202 -5 226 -24 268 -30 63 -77 106 -137 124 -53 16 -154 19 -197 6z m201
-396 c-5 -43 -18 -63 -54 -85 -39 -24 -114 -26 -145 -4 -15 11 -22 25 -22 50
0 28 6 38 33 54 26 17 46 20 112 18 l80 -3 -4 -30z"/>
<path d="M4964 6308 l1 -62 138 3 c75 1 137 -1 137 -6 0 -5 -63 -85 -140 -178
l-140 -168 0 -69 0 -68 240 0 240 0 0 65 0 65 -145 0 c-80 0 -145 3 -145 6 0
4 17 27 38 52 20 25 85 104 144 176 l108 131 0 58 0 57 -239 0 -239 0 2 -62z"/>
<path d="M5510 6365 c0 -7 66 -162 152 -360 112 -255 106 -234 77 -290 -27
-53 -74 -85 -126 -85 l-33 0 0 -65 0 -65 69 0 c81 0 115 11 154 48 43 41 73
108 206 461 67 179 127 333 132 343 9 17 4 18 -74 18 l-83 0 -69 -205 c-39
-113 -72 -205 -75 -205 -3 0 -10 15 -16 33 -5 17 -37 110 -69 205 l-60 172
-92 0 c-51 0 -93 -2 -93 -5z"/>
<path d="M2399 5608 c-81 -42 -155 -61 -239 -61 -82 0 -124 10 -215 55 -75 37
-122 35 -252 -14 -129 -49 -196 -91 -288 -183 -133 -132 -182 -251 -192 -467
l-6 -128 344 0 344 0 -3 69 c-4 86 9 137 52 192 50 66 122 99 216 99 175 0
291 -125 277 -296 l-5 -64 344 0 344 0 -4 118 c-2 64 -9 139 -15 166 -28 119
-122 274 -213 348 -112 92 -259 163 -385 186 -44 8 -55 6 -104 -20z"/>
<path d="M6411 5469 c-33 -13 -50 -38 -50 -74 0 -78 93 -113 143 -54 32 38 33
70 4 103 -27 30 -63 39 -97 25z"/>
<path d="M7466 5473 c-30 -8 -55 -44 -56 -79 0 -45 27 -74 75 -81 34 -4 44 -1
68 22 36 37 36 78 -2 116 -28 28 -44 32 -85 22z"/>
<path d="M5209 5463 c0 -5 0 -65 1 -135 1 -83 -3 -128 -10 -128 -5 0 -10 4
-10 10 0 21 -79 50 -137 50 -155 -1 -251 -122 -241 -304 9 -159 99 -255 240
-256 64 0 103 12 136 42 l22 21 0 -26 c0 -27 1 -27 70 -27 l70 0 0 380 0 380
-70 0 c-38 0 -70 -3 -71 -7z m-54 -345 c35 -27 55 -75 55 -130 0 -104 -46
-168 -122 -168 -98 0 -152 87 -128 206 15 71 61 114 124 114 29 0 52 -7 71
-22z"/>
<path d="M5857 5443 c-2 -5 -34 -91 -70 -193 -37 -102 -95 -265 -130 -362
l-64 -178 82 0 81 0 25 78 25 77 143 0 c83 0 146 -4 150 -10 5 -5 18 -40 30
-77 l23 -68 80 0 c60 0 79 3 76 13 -3 6 -63 173 -134 370 l-129 357 -92 0
c-50 0 -94 -3 -96 -7z m193 -440 c0 -10 -27 -13 -101 -13 -81 0 -100 3 -96 14
6 14 86 261 93 285 4 14 104 -262 104 -286z"/>
<path d="M7060 5320 l0 -70 -35 0 -35 0 0 -60 0 -60 35 0 35 0 0 -124 c0 -252
35 -306 200 -306 l70 0 0 64 0 64 -39 -5 c-31 -4 -43 -1 -60 16 -19 19 -21 32
-21 156 l0 135 65 0 65 0 0 60 0 60 -65 0 -65 0 0 70 0 70 -75 0 -75 0 0 -70z"/>
<path d="M3797 5246 c-49 -18 -64 -32 -88 -77 -29 -58 -26 -75 19 -83 73 -12
102 -8 102 14 0 31 43 54 93 47 50 -7 87 -44 87 -86 l0 -29 -98 -4 c-115 -4
-182 -31 -220 -88 -20 -30 -23 -45 -20 -99 4 -58 7 -66 40 -96 45 -42 119 -59
186 -44 49 11 92 33 105 56 15 25 29 14 22 -17 l-7 -30 66 0 66 0 0 178 c0
247 -20 306 -121 352 -52 23 -173 27 -232 6z m213 -337 c0 -22 -10 -41 -34
-65 -29 -29 -41 -34 -82 -34 -30 0 -54 6 -66 17 -22 20 -24 66 -2 84 17 14 76
26 142 28 41 1 42 0 42 -30z"/>
<path d="M4465 5248 c-11 -6 -30 -20 -42 -31 l-23 -20 0 26 c0 27 0 27 -75 27
l-75 0 0 -270 0 -270 74 0 75 0 3 184 c3 179 4 185 27 210 33 35 98 36 138 2
l28 -24 3 -186 3 -186 75 0 75 0 -3 208 c-3 199 -4 209 -28 251 -34 61 -92 91
-174 91 -34 0 -70 -6 -81 -12z"/>
<path d="M6840 5252 c-27 -12 -56 -36 -68 -57 -10 -18 -11 -16 -12 18 l0 37
-75 0 -75 0 0 -270 0 -270 75 0 75 0 0 163 0 164 33 37 c27 31 40 38 85 43
l52 6 0 68 0 69 -37 -1 c-21 0 -45 -3 -53 -7z"/>
<path d="M7863 5239 c-18 -12 -33 -25 -33 -30 0 -5 -4 -9 -10 -9 -5 0 -10 11
-10 25 0 24 -2 25 -75 25 l-75 0 0 -270 0 -270 74 0 75 0 3 186 3 186 28 24
c38 33 99 33 132 0 31 -31 37 -79 33 -254 l-3 -142 73 0 72 0 0 168 c0 139 3
173 18 202 20 41 54 56 106 46 64 -12 71 -34 74 -238 l4 -178 69 0 69 0 0 188
c0 193 -8 246 -42 295 -29 40 -88 67 -148 67 -65 0 -108 -18 -147 -63 l-31
-36 -23 34 c-13 18 -38 40 -56 49 -49 23 -140 21 -180 -5z"/>
<path d="M8736 5253 c-62 -16 -136 -90 -162 -160 -20 -58 -17 -163 6 -227 25
-65 99 -139 156 -155 52 -14 147 -14 198 1 38 12 136 95 136 116 0 5 -23 19
-50 32 l-50 24 -28 -26 c-37 -35 -65 -48 -102 -48 -58 0 -121 48 -134 103 l-6
27 196 0 197 0 -5 64 c-10 119 -74 213 -167 244 -33 12 -147 14 -185 5z m144
-118 c33 -17 60 -52 60 -77 0 -16 -12 -18 -120 -18 -66 0 -120 2 -120 5 0 2 7
19 16 38 29 62 101 84 164 52z"/>
<path d="M6370 4980 l0 -270 75 0 75 0 0 270 0 270 -75 0 -75 0 0 -270z"/>
<path d="M7420 4980 l0 -270 75 0 75 0 0 270 0 270 -75 0 -75 0 0 -270z"/>
<path d="M2088 4997 c-36 -30 -48 -58 -48 -109 0 -43 30 -108 50 -108 7 0 10
-43 8 -127 l-3 -126 -130 -49 c-71 -27 -188 -69 -258 -95 l-128 -46 -16 24
c-36 54 -103 108 -160 129 -130 49 -285 -10 -360 -138 -35 -59 -44 -175 -19
-250 20 -60 81 -133 143 -169 59 -34 159 -43 231 -19 98 33 182 133 200 237
l7 43 160 59 c88 32 195 72 238 88 43 16 83 29 88 29 5 0 9 -49 9 -109 l0
-108 -27 -6 c-72 -15 -166 -107 -193 -190 -18 -58 -9 -172 18 -229 90 -184
335 -225 479 -81 55 55 76 105 81 191 8 139 -43 231 -161 291 l-67 34 0 104
c0 76 3 103 13 102 6 0 117 -39 246 -87 l235 -87 11 -51 c48 -215 274 -311
458 -194 56 36 109 114 127 188 39 165 -82 342 -252 367 -101 15 -221 -36
-283 -122 -16 -23 -34 -42 -40 -42 -5 -1 -50 14 -100 33 -49 19 -162 61 -250
94 l-160 59 -3 123 c-3 123 -3 123 25 152 24 25 28 37 28 89 0 57 -2 63 -37
95 -32 29 -45 34 -85 34 -35 0 -55 -6 -75 -23z m-701 -659 c39 -27 73 -91 73
-139 0 -156 -218 -208 -291 -69 -25 46 -24 96 4 150 39 78 143 105 214 58z
m1713 4 c51 -25 80 -74 80 -136 0 -93 -62 -156 -154 -156 -62 0 -110 29 -137
83 -68 133 77 277 211 209z m-873 -338 c112 -46 125 -203 23 -272 -49 -33
-146 -28 -186 8 -57 53 -71 142 -31 201 49 73 118 95 194 63z"/>
<path d="M3812 4465 c-94 -41 -144 -111 -145 -203 0 -63 16 -103 60 -143 39
-37 75 -54 176 -82 101 -28 134 -48 143 -82 17 -68 -37 -119 -119 -112 -57 5
-96 30 -117 76 -15 31 -16 32 -65 26 -103 -13 -109 -18 -79 -78 57 -113 184
-171 324 -147 91 15 152 55 185 121 40 78 31 178 -21 234 -45 49 -84 67 -236
109 -32 9 -67 26 -78 38 -47 51 -7 127 70 134 58 6 90 -11 115 -61 11 -22 21
-42 22 -44 4 -8 143 32 143 41 0 5 -9 30 -20 56 -23 52 -86 107 -141 122 -50
15 -179 11 -217 -5z"/>
<path d="M4282 4195 c3 -268 4 -282 26 -322 53 -101 122 -145 242 -157 157
-17 286 57 331 187 16 45 18 89 19 312 l0 260 -72 0 -73 0 -5 -255 c-4 -208
-8 -262 -22 -292 -45 -101 -224 -102 -274 -1 -17 33 -20 70 -24 293 l-5 255
-73 0 -73 0 3 -280z"/>
<path d="M5002 4101 l3 -374 178 2 c195 3 255 14 307 57 45 39 63 81 64 149 1
76 -29 133 -86 165 l-40 22 31 19 c58 35 81 104 61 180 -16 59 -44 95 -93 122
-38 19 -61 22 -235 27 l-192 5 2 -374z m322 228 c32 -15 50 -66 37 -102 -15
-38 -60 -57 -136 -57 l-65 0 0 85 0 85 70 0 c38 0 80 -5 94 -11z m27 -302 c31
-21 34 -27 34 -72 0 -45 -3 -51 -34 -72 -28 -19 -47 -23 -112 -23 l-79 0 0 95
0 95 79 0 c65 0 84 -4 112 -23z"/>
<path d="M3650 3280 l0 -111 67 3 c60 3 69 6 79 27 13 26 1 81 -18 81 -6 0 -6
6 1 14 7 8 11 27 9 43 -4 34 -37 53 -95 53 l-43 0 0 -110z m100 45 c0 -21 -5
-25 -30 -25 -25 0 -30 4 -30 25 0 21 5 25 30 25 25 0 30 -4 30 -25z m-2 -64
c8 -4 12 -19 10 -32 -2 -19 -10 -25 -35 -27 -32 -3 -33 -2 -33 32 0 31 3 36
23 36 12 0 28 -4 35 -9z"/>
<path d="M3857 3383 c-11 -11 -8 -137 4 -172 18 -52 85 -67 133 -30 25 19 26
25 26 115 0 87 -1 94 -20 94 -18 0 -20 -7 -20 -79 0 -99 -5 -111 -41 -111 -39
0 -49 24 -49 114 0 57 -3 76 -13 76 -8 0 -17 -3 -20 -7z"/>
<path d="M4060 3385 c0 -2 14 -28 32 -57 21 -35 34 -71 37 -107 5 -41 10 -55
24 -57 14 -2 17 6 17 43 0 36 8 59 40 109 22 35 40 66 40 69 0 3 -10 5 -23 5
-18 0 -29 -11 -46 -45 -12 -25 -24 -45 -26 -45 -2 0 -15 20 -29 45 -17 29 -34
45 -46 45 -11 0 -20 -2 -20 -5z"/>
<path d="M4389 3386 c-2 -2 -3 -53 -1 -113 l3 -109 61 6 c50 5 65 11 84 34 45
51 28 143 -31 171 -30 14 -106 21 -116 11z m113 -53 c43 -38 10 -133 -46 -133
-28 0 -36 21 -36 98 0 52 0 52 32 52 17 0 40 -7 50 -17z"/>
<path d="M4666 3381 c-4 -6 -22 -55 -40 -111 l-34 -100 23 0 c16 0 25 7 29 25
5 21 12 25 46 25 34 0 41 -4 46 -24 6 -25 44 -44 44 -22 0 6 -16 56 -35 111
-26 76 -39 101 -54 103 -10 2 -22 -1 -25 -7z m39 -93 c7 -36 6 -38 -20 -38
-22 0 -26 3 -20 18 3 9 9 30 12 45 7 35 19 24 28 -25z"/>
<path d="M4790 3369 c0 -18 5 -21 30 -17 l30 5 0 -94 c0 -86 1 -93 20 -93 19
0 20 7 20 90 l0 90 30 0 c23 0 30 4 30 20 0 18 -7 20 -80 20 -75 0 -80 -1 -80
-21z"/>
<path d="M4996 3288 c-20 -57 -36 -108 -36 -115 0 -21 38 -2 44 23 5 20 12 24
46 24 33 0 42 -4 49 -24 10 -23 37 -41 44 -28 3 4 -12 54 -32 112 -29 85 -40
106 -57 108 -18 3 -26 -10 -58 -100z m77 -30 c-2 -5 -13 -8 -25 -8 -18 0 -19
4 -13 37 4 21 9 42 13 47 6 11 31 -65 25 -76z"/>
<path d="M5321 3305 c-45 -126 -47 -135 -23 -135 13 0 22 9 26 25 5 21 12 25
46 25 34 0 41 -4 46 -24 5 -21 36 -41 47 -30 2 2 -12 54 -32 114 -31 96 -38
110 -57 110 -19 0 -27 -13 -53 -85z m72 -47 c-2 -5 -13 -8 -25 -8 -18 0 -19 4
-13 37 4 21 9 42 13 47 6 11 31 -65 25 -76z"/>
<path d="M5470 3369 c0 -18 5 -21 30 -17 l30 5 0 -93 c0 -83 2 -92 20 -97 19
-5 20 0 20 92 l0 98 30 -5 c25 -4 30 -1 30 17 0 20 -5 21 -80 21 -75 0 -80 -1
-80 -21z"/>
<path d="M5801 3306 c-45 -127 -47 -136 -23 -136 13 0 22 9 26 25 5 21 12 25
46 25 34 0 41 -4 46 -24 5 -22 36 -41 47 -30 3 3 -12 53 -32 112 -29 88 -40
108 -57 110 -19 3 -26 -8 -53 -82z m72 -48 c-2 -5 -13 -8 -25 -8 -18 0 -19 4
-13 37 4 21 9 42 13 47 6 11 31 -65 25 -76z"/>
<path d="M6000 3276 c0 -103 2 -114 18 -112 13 2 18 14 20 50 l3 47 37 -3 c29
-2 37 1 40 15 3 14 -4 17 -37 17 -39 0 -41 2 -41 30 0 29 2 30 46 30 38 0 45
3 42 18 -3 14 -16 18 -66 20 l-62 3 0 -115z"/>
<path d="M6180 3280 c0 -103 1 -110 20 -110 17 0 20 7 20 46 l0 46 37 -4 c30
-2 38 1 41 15 3 14 -4 17 -37 17 -40 0 -41 1 -41 33 0 32 0 32 45 29 40 -4 45
-2 45 17 0 19 -6 21 -65 21 l-65 0 0 -110z"/>
<path d="M6387 3366 c-52 -48 -44 -161 13 -191 99 -51 192 49 147 158 -26 60
-111 78 -160 33z m120 -43 c17 -26 13 -84 -8 -109 -6 -8 -26 -14 -44 -14 -38
0 -54 16 -62 63 -13 81 71 126 114 60z"/>
<path d="M6620 3281 c0 -104 1 -111 20 -111 17 0 20 7 20 40 0 50 14 51 39 1
18 -34 51 -57 65 -44 3 3 -6 23 -20 44 l-24 39 20 20 c25 25 26 61 2 90 -13
16 -32 24 -70 28 l-52 5 0 -112z m95 34 c0 -26 -3 -30 -29 -30 -26 0 -30 4
-31 33 -1 31 0 33 29 30 27 -3 31 -7 31 -33z"/>
<path d="M6820 3281 l0 -111 60 0 c51 0 65 4 85 24 31 31 40 69 29 114 -12 48
-51 74 -119 80 l-55 4 0 -111z m119 55 c7 -8 15 -31 18 -51 7 -45 -25 -85 -69
-85 l-28 0 0 75 0 75 34 0 c18 0 39 -6 45 -14z"/>
<path d="M7066 3283 c-20 -60 -36 -111 -36 -114 0 -3 7 -6 16 -6 10 0 22 13
28 29 9 25 15 28 52 28 37 0 43 -3 46 -22 2 -15 11 -24 27 -26 17 -3 22 0 19
10 -3 7 -20 57 -39 110 -28 82 -37 98 -55 98 -18 0 -27 -17 -58 -107z m83 -20
c1 -8 -9 -12 -24 -11 -29 3 -28 0 -13 51 l12 40 12 -34 c7 -19 13 -40 13 -46z"/>
<path d="M7270 3280 l0 -110 63 0 c36 0 68 5 75 12 17 17 15 73 -3 88 -11 9
-12 16 -4 26 6 7 9 25 7 41 -4 34 -37 53 -95 53 l-43 0 0 -110z m98 48 c-2
-14 -13 -24 -30 -29 -26 -7 -28 -5 -28 22 0 26 3 29 31 29 26 0 30 -3 27 -22z
m0 -67 c8 -4 12 -19 10 -32 -2 -19 -10 -25 -35 -27 -32 -3 -33 -2 -33 32 0 31
3 36 23 36 12 0 28 -4 35 -9z"/>
<path d="M7480 3280 l0 -110 65 0 c51 0 65 3 65 15 0 11 -12 15 -45 15 l-45 0
0 95 c0 88 -1 95 -20 95 -19 0 -20 -7 -20 -110z"/>
<path d="M7660 3280 l0 -110 55 0 c30 0 58 -1 63 -2 4 -1 8 6 10 15 3 14 -5
17 -42 17 -44 0 -46 1 -46 30 0 28 2 30 40 30 29 0 40 4 40 15 0 11 -11 15
-40 15 -38 0 -40 2 -40 30 0 29 2 30 45 30 38 0 45 3 45 20 0 18 -7 20 -65 20
l-65 0 0 -110z"/>
<path d="M7940 3282 c0 -101 2 -110 20 -115 17 -4 20 0 20 34 0 37 2 39 30 39
42 0 70 31 70 79 0 49 -17 63 -86 69 l-54 4 0 -110z m98 30 c3 -30 1 -32 -27
-32 -29 0 -31 2 -31 39 0 38 1 39 28 32 21 -6 28 -14 30 -39z"/>
<path d="M8140 3276 c0 -109 1 -115 20 -113 17 1 20 8 20 44 0 55 19 56 44 4
16 -34 51 -59 64 -46 2 2 -6 22 -19 44 -21 38 -21 42 -6 59 9 10 17 35 17 55
0 46 -28 67 -92 67 l-48 0 0 -114z m95 39 c0 -25 -4 -30 -27 -33 -26 -3 -28
-1 -28 33 0 34 2 36 28 33 23 -3 27 -8 27 -33z"/>
<path d="M8350 3281 c0 -100 2 -109 20 -114 19 -5 20 0 20 109 0 107 -1 114
-20 114 -19 0 -20 -7 -20 -109z"/>
<path d="M8493 3380 c-50 -20 -69 -119 -34 -177 33 -53 121 -56 162 -5 19 25
19 27 2 33 -12 5 -23 1 -32 -12 -19 -27 -75 -25 -95 3 -20 28 -20 87 -1 112
21 27 73 26 94 -3 23 -30 65 -16 43 15 -27 38 -90 54 -139 34z"/>
<path d="M8700 3280 l0 -110 65 0 c51 0 65 3 65 15 0 11 -12 15 -49 15 -49 0
-50 1 -49 30 1 29 3 30 45 30 32 0 43 4 43 15 0 11 -12 15 -44 15 -41 0 -43 2
-42 28 1 24 5 27 46 32 31 3 45 10 45 20 0 11 -15 16 -62 18 l-63 3 0 -111z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
